// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textarea-sidebar {\n  padding-right: 14px;\n}\ntextarea {\n  height: 100px;\n  width: 100%;\n}\n.subli {\n  border-left: 5px solid #8080804a;\n  border-top: 5px solid #8080804a;\n  padding-left: 8px;\n}\nli h3 {\n  border-bottom: 1px solid #80808057;\n}\nli h3, li h4 {\n  margin-top: 20px;\n}\nh4 span {\n  opacity: .7;\n  font-size: 0.8em;\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
